var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * StarHalfFilled icon component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconStarHalfFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.0983 1.61169C17.0981 1.40509 17.0156 1.20709 16.869 1.0615C16.7225 0.915916 16.5239 0.834743 16.3173 0.835951C16.0069 0.837766 15.7036 0.929 15.4437 1.09873C15.1866 1.26662 14.9828 1.50427 14.856 1.78376L12.39 6.99492C12.3861 7.00322 12.3823 7.01161 12.3786 7.02006C12.3765 7.02501 12.3731 7.02931 12.3688 7.03256C12.3646 7.0358 12.3595 7.03789 12.3541 7.03858L12.3444 7.03992L6.84718 7.83189L6.83457 7.83382C6.52349 7.88385 6.2328 8.02053 5.99581 8.22815C5.75881 8.43577 5.58509 8.70594 5.49456 9.00773C5.40402 9.30952 5.40033 9.6307 5.4839 9.9345C5.56524 10.2302 5.72602 10.4977 5.94858 10.7082L9.91106 14.779L9.91509 14.7831C9.92882 14.797 9.93909 14.814 9.94503 14.8326C9.95075 14.8504 9.95235 14.8693 9.94972 14.8878L8.95764 20.6234L8.95724 20.6257C8.90435 20.9249 8.93533 21.233 9.04678 21.5158C9.15852 21.7992 9.34677 22.0461 9.59054 22.2289C9.83431 22.4118 10.1241 22.5233 10.4275 22.5513C10.7309 22.5792 11.0361 22.5223 11.3092 22.387C11.3179 22.3827 11.3267 22.3781 11.3353 22.3735L16.3012 19.6732C16.3358 19.6604 17.1172 19.1914 17.1139 19L17.0983 1.61169Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconStarHalfFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarHalfFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconStarHalfFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-star-half-filled') === undefined) {
    customElements.define('cat-icon-star-half-filled', BlocksIconStarHalfFilled);
}
